import wretch from 'wretch';
import omitBy from 'lodash/omitBy';
import isUndefined from 'lodash/isUndefined';

import { IBusinessUnitsModel } from '@crm-package/dictionaries';

import {
  INotificationTypeFromServer,
  INotificationsModelFromServer,
  INotificationsFilter,
} from './types';

function getNotificationTypes(): Promise<INotificationTypeFromServer[]> {
  return wretch('/api/notification-types').get().json();
}

function getNotifications({
  limit,
  offset,
  notificationType,
  businessUnitsIds,
}: INotificationsFilter): Promise<INotificationsModelFromServer> {
  const requestModel = omitBy<INotificationsFilter>(
    {
      limit,
      offset,
      notificationType,
      businessUnitsIds,
    },
    isUndefined
  );

  return wretch('/api/notifications').post(requestModel).json();
}

function markAsRead(ids: number[]): Promise<void> {
  return wretch('/api/notifications/read').put(ids).res();
}

function deleteNotifications(ids: number[]): Promise<void> {
  return wretch('/api/notifications/delete').put(ids).res();
}

function getBusinessUnitsApi(): Promise<IBusinessUnitsModel[]> {
  return wretch('/api/dictionaries/business-units').get().json();
}

export const notificationsApi = {
  getNotificationTypes,
  getNotifications,
  markAsRead,
  deleteNotifications,
  getBusinessUnitsApi,
};
